import _get from 'lodash/get';
import _set from 'lodash/set';
import _unset from 'lodash/unset';
import { post } from '@/lib/utils';
import {
  removeMessages,
  remove_messages,
} from '@/lib/vuexUtils';

const localState = {
  record: {},
};

const localGetters = {
  record: state => state.record,
};

const localActions = {
  removeMessages,

  async save({ commit }, { url, rawParams, parentPath }) {
    let record;
    try {
      commit('editObject/set_save_in_flight', true, { root: true });
      const { results } = await post(url, rawParams);
      record = results[0];
      if (record) {
        // Presence of record indicative of error, otherwise empty list.
        _unset(record, 'transactionid');
        commit('set_model', { model: record, parentPath });
      } else {
        // Guarantee that the last saved transaction id cannot be sent again
        const { newtransactionid, transactionid } = rawParams.ArTran;
        if (newtransactionid) _unset(rawParams, 'ArTran.newtransactionid');
        else if (transactionid) _unset(rawParams, 'ArTran.transactionid');
      }
    } finally {
      commit('editObject/set_save_in_flight', false, { root: true });
    }
    return record;
  },

  async getTransactionId() {
    const { results } = await post('/tg/artran/get_nexttransactionid');
    return results[0].newtransactionid;
  },

  updateValue({ commit }, payload) {
    commit('update_object', payload);
  },

  setModel({ commit }, payload) {
    commit('set_model', payload);
  },
};

const localMutations = {
  remove_messages,

  update_object(state, { path, key, value }) {
    const stateObject = _get(state, path);
    _set(stateObject, key, value);
  },

  set_model(state, { model, parentPath }) {
    state[parentPath] = model;
  },
};

export default {
  namespaced: true,
  state: localState,
  getters: localGetters,
  actions: localActions,
  mutations: localMutations,
};
